import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import useOrganization from '~/components/OrganizationContext';

import CapacityAgreements from '../PolicyDetails/CapacityAgreements/CapacityAgreements';
import PolicyDetailsCard from '../PolicyDetails/PolicyDetailsCard';

const DetailsTab: React.FC = () => {
  const { claim, onAsyncClaimUpdate } = useClaim({ claimRequired: true });
  // @ts-expect-error TS233 useOrganization() not properly typed yet
  const { coverageConfiguration, organizationId } = useOrganization();

  const hasCapacityAgreementsRail = Boolean(coverageConfiguration?.is_capacity_agreement_enabled);
  const detailsColumns = hasCapacityAgreementsRail ? 3 : 4;

  return (
    <div className="p-12">
      <div className="flex flex-col items-start gap-24 lg:flex-row">
        <div className={`w-full ${hasCapacityAgreementsRail ? 'lg:w-7/12' : ''}`}>
          <PolicyDetailsCard claim={claim} onClaimUpdate={onAsyncClaimUpdate} numColumns={detailsColumns} />
        </div>
        {hasCapacityAgreementsRail ? (
          <div className="w-full lg:w-5/12">
            <CapacityAgreements claim={claim} organizationId={organizationId} onUpdateSuccess={onAsyncClaimUpdate} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default DetailsTab;
